var darkmode = localStorage.getItem('dark-mode')
if (darkmode == "True") {
 var htags = document.querySelectorAll('.h0, .h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6');
 for (var i = 0; i < htags.length; i++) {
  htags[i].classList.add('dark');
 }
 var bodyclasses = document.querySelectorAll('.bg-2--text, .price, .product-info-block_title, .product-form__input input[type="radio"] + .color-swatch, .product-form__input input[type=radio]+label');
 for (var i = 0; i < bodyclasses.length; i++) {
  bodyclasses[i].classList.add('dark');
 }
 var bodyclassestwo = document.querySelectorAll('.field__input, .field__label, .article-card__info, .link, .slfe-light-dark-uniclass, .slider-button');
 for (var i = 0; i < bodyclassestwo.length; i++) {
  bodyclassestwo[i].classList.add('dark');
 }
 document.querySelector('.cart-notification').classList.add('dark');
}